'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

var _extends = require('../../../external/@babel/runtime/helpers/esm/extends.js');

var objectWithoutProperties = require('../../../external/@babel/runtime/helpers/esm/objectWithoutProperties.js');

var React = require('react');

var PropTypes = require('prop-types');

var index = require('../../../external/classnames/index.js');

var index$1 = require('../../../utilities/GatsbyLink/index.js');

function _interopDefault(e) {
  return e && e.__esModule ? e : {
    'default': e
  };
}

var React__default = /*#__PURE__*/_interopDefault(React);

var PropTypes__default = /*#__PURE__*/_interopDefault(PropTypes);

var _excluded = ["className", "src", "alt", "link", "standard", "tag", "top"];

var CardImage = function CardImage(props) {
  var className = props.className,
      src = props.src,
      alt = props.alt,
      link = props.link,
      standard = props.standard,
      tag = props.tag,
      top = props.top,
      attributes = objectWithoutProperties['default'](props, _excluded);
  var classes = index['default'](top && 'card-img-top', link && 'lanl-card-content', standard && 'img-card-std-height', 'lanl-img-card', className);
  var Tag = tag;
  var innerContent = /*#__PURE__*/React__default['default'].createElement(Tag, _extends['default']({
    "data-testid": "card-image",
    alt: alt,
    src: src
  }, attributes, {
    className: classes
  }));

  if (link) {
    return /*#__PURE__*/React__default['default'].createElement("div", {
      className: "card-image-view"
    }, /*#__PURE__*/React__default['default'].createElement(index$1['default'], {
      className: "lanl-card-img-container",
      href: link
    }, /*#__PURE__*/React__default['default'].createElement("div", {
      className: "rollover"
    }, innerContent)));
  }

  return /*#__PURE__*/React__default['default'].createElement("div", {
    className: "card-image-view"
  }, /*#__PURE__*/React__default['default'].createElement("div", {
    className: "rollover"
  }, innerContent));
};

CardImage.propTypes = {
  src: PropTypes__default['default'].string.isRequired,
  alt: PropTypes__default['default'].string,
  className: PropTypes__default['default'].string,
  link: PropTypes__default['default'].string,
  standard: PropTypes__default['default'].bool,
  tag: PropTypes__default['default'].oneOfType([PropTypes__default['default'].func, PropTypes__default['default'].string]),
  top: PropTypes__default['default'].bool
};
CardImage.defaultProps = {
  tag: 'img',
  standard: true
};
exports.CardImage = CardImage;
exports['default'] = CardImage;